import React from "react";
import { useNavigate } from "react-router-dom";

import { Identifiable, Log as LogDto } from "@planzone/dto";
import { useModal } from "@root/client/modal/utils";
import { Flag, InfiniteScroll } from "@common/infiniteScroll";
import { Card } from "../skeleton/card";
import { Log } from "./log";
import { logRedirection } from "./utils";
import { Props } from "./types";
import styles from "./styles.scss";

function removeDuplicates(
  logs: Identifiable<LogDto>[],
): Identifiable<LogDto>[] {
  return logs.reduce((array, current) => {
    const isUndefined =
      array.find((item) => item.uuid === current.uuid) === undefined;
    if (isUndefined) {
      array.push(current);
    }
    return array;
  }, [] as Identifiable<LogDto>[]);
}

function Logs({
  logs,
  isRequestPending,
  canLoadNextPage,
  loadNextPage,
}: Props) {
  const navigate = useNavigate();
  const { pushView } = useModal();
  const sortedLogs = removeDuplicates(
    [...logs].sort((a, b) => {
      const date1 = new Date(a.createdDate);
      const date2 = new Date(b.createdDate);
      return date1 < date2 ? 1 : date1 > date2 ? -1 : 0;
    }),
  ).filter((log) =>
    log.content.includes("update") ? log.attributes.target : true,
  );

  return (
    <div className={styles.logs}>
      <InfiniteScroll className={styles.list} canFetchOnIdle={canLoadNextPage}>
        {() => (
          <React.Fragment>
            {sortedLogs.map((log, key) => (
              <div
                className={styles.log}
                key={key}
                onClick={() => {
                  logRedirection(log)(
                    log,
                    (path) => {
                      navigate(path);
                    },
                    pushView,
                  );
                }}
              >
                <Log log={log} />
              </div>
            ))}
            {isRequestPending && (
              <div className={styles.skeleton}>
                <div className={styles.log}>
                  <Card />
                </div>
                <div className={styles.log}>
                  <Card />
                </div>
              </div>
            )}
            <Flag
              name="logsFlag"
              retrieveItems={() => canLoadNextPage && loadNextPage()}
              isDisabled={isRequestPending}
            />
          </React.Fragment>
        )}
      </InfiniteScroll>
    </div>
  );
}

export { Logs };
